import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import {
    Avatar,
    Button,
    Dropdown,
    MenuProps,
    Skeleton,
    Typography,
} from 'antd';
import authApi, {
    useUserProfileQuery,
    useLogoutMutation,
} from '../../features/auth/authApi';
import { useNavigate } from 'react-router-dom';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';
import courseApi from '../../features/courses/coursesApi';
import { useAppDispatch } from '../../hooks';

const { Text } = Typography;

const UserProfileAvatar = ({ collapsed = false }: { collapsed?: boolean }) => {
    const { t } = useTranslation();
    const { data, isSuccess } = useUserProfileQuery('userDetails');
    const [logout, {}] = useLogoutMutation();
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const menuItems: MenuProps['items'] = [
        {
            label: t('profile.header'),
            key: 'profile',
            icon: <UserOutlined />,
        },
        {
            label: t('logout'),
            key: 'logout',
            icon: <LogoutIcon />,
        },
    ];

    const onMenuClick = (e) => {
        if (e.key === 'logout') {
            logout()
                .unwrap()
                .catch(() => undefined)
                .finally(() => {
                    dispatch(authApi.util.resetApiState());
                    dispatch(courseApi.util.resetApiState());
                    navigate('/app/');
                });
        } else if (e.key === 'profile') {
            navigate('/app/profile');
        }
    };

    if (isSuccess) {
        return (
            <Dropdown
                menu={{ items: menuItems, onClick: onMenuClick }}
                placement="topLeft"
                arrow
                trigger={['click']}
            >
                <Button
                    size="large"
                    block={!collapsed}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: collapsed ? 'center' : 'flex-start',
                        gap: 8,
                    }}
                >
                    <div
                        data-cy="top-right-avatar"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            minWidth: 0,
                        }}
                    >
                        <Avatar
                            size={'small'}
                            icon={<UserOutlined />}
                            src={data?.profile_picture}
                        />
                        {!collapsed && (
                            <Text ellipsis>{data?.username}</Text>
                        )}
                    </div>
                </Button>
            </Dropdown>
        );
    } else {
        return (
            <div style={{ textAlign: 'center' }}>
                <Skeleton.Avatar active />
            </div>
        );
    }
};

export default UserProfileAvatar;
